(ns ballot-scout-v2-frontend.email.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.widget.events :as e.widget]
   [day8.re-frame.http-fx]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::verify-email
 (fn [_ [_ {:keys [query-params] :as _route}]]
   {:http-xhrio {:method :post
                 :uri (urls/verify-email (:user-token query-params))
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::verify-email-success]
                 :on-failure [::verify-email-failure]}}))

(rf/reg-event-fx
 ::verify-email-success
 (fn [{:keys [db]} [_ response]]
   (let [lang-code (or (:lang response) "en")]
     {:db (assoc-in db [:verify-email :success] response)
      :dispatch [::e.widget/set-lang-code lang-code]})))

(rf/reg-event-fx
 ::verify-email-failure
 (fn [{:keys [db]} [_ response]]
   (let [lang-code (or (:lang response) "en")]
     {:db (assoc-in db [:verify-email :failure] response)
      :dispatch [::e.widget/set-lang-code lang-code]})))

(rf/reg-event-fx
 ::unsubscribe-email
 (fn [_ [_ {:keys [query-params] :as _route}]]
   {:http-xhrio {:method :post
                 :uri (urls/unsubscribe-email (:user-token query-params))
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::unsubscribe-email-success]
                 :on-failure [::unsubscribe-email-failure]}}))

(rf/reg-event-fx
 ::unsubscribe-email-success
 (fn [{:keys [db]} [_ response]]
   (let [lang-code (or (:lang response) "en")]
     {:db (assoc-in db [:unsubscribe-email :success] response)
      :dispatch [::e.widget/set-lang-code lang-code]})))

(rf/reg-event-fx
 ::unsubscribe-email-failure
 (fn [{:keys [db]} [_ response]]
   (let [lang-code (or (:lang response) "en")]
     {:db (assoc-in db [:unsubscribe-email :failure] response)
      :dispatch [::e.widget/set-lang-code lang-code]})))
